import { calculateStageScore, DONE_STATUSES } from './calculateScores';
import { STAGES_MAP } from './getStopsStatusLog';

const isStageClickable = (stage, { stopId, score, stops }) => {
  const stopsStatuses = stops.map(({ status }) => status);

  const canStart = stopsStatuses.slice(0, stopId).every((status) => DONE_STATUSES.includes(status));

  const stageScore = calculateStageScore(stage);

  const isNextStage = score < stageScore && stageScore === score + 1;
  const isNotStarted = score === 0 && canStart && stage === STAGES_MAP.ONROUTE;

  return isNextStage || isNotStarted;
};

export { isStageClickable };
